var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconCoyote = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.278 8.642c-.733-.204-.63-.87-1.858-1.159-.03-.494-.03-.99 0-1.483 0 0-.903 1.09-1.431 1.705a4.432 4.432 0 0 1-2.319 1.04c-1.602.272-6.92.988-8.522.988a2.727 2.727 0 0 0-1.603.375 3.614 3.614 0 0 0-2.897.835c-1.5 1.705-2.472 4.21-3.648 5.114 1.164.41 2.46.058 3.256-.887 1.431-1.806 1.33-3.75 3.05-4.772a6 6 0 0 0-.732.92 10.38 10.38 0 0 0-.63 4.074l-1.79 2.046-.256 2.846h.852l.46-2.08 1.364-.681a5.114 5.114 0 0 0 2.216-2.455c0-.102 0-.187.136-.273.165.66.4 1.3.699 1.91.256.545-.63 1.363-.256 1.806.375.444 1.228 1.705 1.228 1.705h1.193c0-.41-.222-.563-.716-.886-.188-.103-.767-.75-.443-1.347a30.051 30.051 0 0 0 1.704-3.494c1.296.426 1.977.477 2.148.613v3.409l.392 1.313c.083.29.346.49.648.494h.613a16.227 16.227 0 0 1-.58-1.534 7.313 7.313 0 0 1 1.007-3.221l.221-.393c.835.887 3 2.728 3 3.24a1.16 1.16 0 0 0 .614 1.09c.699.324.375-1.074.358-1.313a23.301 23.301 0 0 0-1.483-2.215 8.523 8.523 0 0 1-.784-2.353c.306-.272.664-.562 1.21-1.074.545-.51 1.278-1.465 1.704-1.704a8.83 8.83 0 0 1 2.83-.716c.699 0 .75-.648.767-1.142-.188-.051-1.142-.222-1.722-.341z",
    fill: "#1A202C",
    fillRule: "nonzero"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCoyote, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-coyote.9c50fbbd.svg";
export { ForwardRef as ReactComponent };